const notifications = {
  paymentError: "Le paiement n'a pas abouti",
  paymentSuccess: "Paiement réussi !",
  paymentAlreadyDone: "Le paiement est déjà effectué",
  alreadySubscribed: "Vous êtes déjà abonné",
  passwordChanged: "Mot de passe modifié avec succès !",
  errorChangingPassword: "Erreur lors du changement du mot de passe !",
  invalidOldPassword: "L'ancien mot de passe n'est pas valide.",
  passwordConfirmationDontMatch:
    "Le nouveau mot de passe et la confirmation ne correspondent pas.",
  emailExists: "Cet email est déjà associé à un compte iizenglish actif.",
  validationMailResent: "Un mail de validation de compte a été renvoyé !",
  signupError:
    "Une erreur a été rencontrée lors de votre inscription. Merci de contacter un administrateur.",
  loginError:
    "Une erreur a été rencontrée lors de votre connexion. Veuillez contacter le responsable de l'application svp.",
  loginNotAllowed:
    "Vous n'êtes pas autorisé à vous connecter depuis cette interface.",
  errorCheckEmail: "Une erreur a été rencontrée, vérifiez votre adresse mail.",
  errorValidatingEmail:
    "Une erreur est survenue lors de la validation de votre adresse mail.",
  setPasswordError:
    "Une erreur a été rencontrée lors de la création de votre mot de passe. Veuillez contacter le responsable de l'application svp.",
  mailValidated: "Adresse mail validée, vous pouvez vous connecter !",
  mailValidationTokenNotFound: "Ce lien de validation n'est plus valide.",
  emailOrPasswordWrong: "L'adresse email et/ou le mot de passe est incorrect.",
  forgotPasswordError:
    "Erreur lors de la demande de ré-initialisation du mot de passe!",
  tokenExpired: "Jeton expiré !",
  tokenExpiredText:
    "Votre demande de nouveau mot de passe a expiré, veuillez faire une nouvelle demande",
  linkExpired: "Lien expiré !",
  badLink: "Lien non valide !",
  anErrorOccurred: "Une erreur est survenue",
  checkCSV: "Veuillez vérifier votre fichier CSV.",
  ifDontUnderstandImportError:
    "Si vous ne comprenez pas d'où vient l'erreur, veuillez envoyer votre fichier CSV ainsi que le contenu ci-dessous à l'équipe de développement.",
  bugs: {
    reportSuccess:
      "Rapport de bug envoyé avec succès. Merci pour votre contribution.",
    reportFailure: "Une erreur s'est produite, merci de réessayer plus tard.",
    serviceUnavailable:
      "Le rapport de bug est indisponible pour le moment, veuillez ré-essayer plus tard après avoir rechargé la page.",
  },
  class: {
    creationSuccess: "Classe sauvegardée.",
    creationFailure: "Erreur lors de la création.",
    creationFailure400:
      "Impossible de sauvegarder la classe, veuillez corriger les erreurs.",
    creationFailure409:
      "Impossible de sauvegarder la classe, celle-ci existe déjà au sein de cet établissement.",
    editionFailure: "Erreur lors de l'édition de la classe.",
    editionFailure400:
      "Impossible de sauvegarder la classe, veuillez corriger les erreurs.",
    getClassesError:
      "Une erreur a été rencontrée lors du chargement des classes. Veuillez contacter le responsable de l'application svp.",
    getClassError:
      "Une erreur a été rencontrée lors du chargement de la classe. Veuillez contacter le responsable de l'application svp.",
    teacherAlreadyInClassError: "Vous étiez déjà professeur de cette classe !",
    teacherJoinsClassSuccess:
      'Vous êtes désormais professeur de cette classe. Vous pourrez la retrouver depuis le menu "Suivre mes classes".',
    deletionSuccess: "La classe a bien été supprimée.",
    deletionFailure:
      "Une erreur a été rencontrée lors de la suppression de la classe. Veuillez contacter le responsable de l'application svp.",
    tooFewLinesInClass: "La classe doit comporter au moins un élève.",
  },
  schools: {
    getSchoolsError:
      "Une erreur a été rencontrée lors du chargement des établissements. Veuillez contacter le responsable de l'application svp.",
    getSchoolError:
      "Une erreur a été rencontrée lors de la récupération de l'établissement. Veuillez contacter un technicien svp.",
    purgeSuccess: "Purge réalisée avec succès !",
    purgeError:
      "Une erreur est survenue durant la purge des établissements sélectionnés. Veuillez contacter un administrateur.",
    updateSchoolError: "Erreur lors de la modification de l'établissement",
    updateSchoolSuccess: "Etablissement modifié avec succès",
    createSchoolSuccess: "Etablissement créé avec succès",
    createSchoolError: "Erreur lors de la création de l'établissement",
    createSchoolAlreadyExistError: "L'établissement existe déjà.",
  },
  students: {
    getStudentsError:
      "Une erreur a été rencontrée lors du chargement des étudiants. Veuillez contacter le responsable de l'application svp.",
    getStudentError:
      "Une erreur a été rencontrée lors de la récupération de l'étudiant. Veuillez contacter un technicien svp.",
    missingPasswordForActivation:
      "Un mot de passe est requis afin d'activer le compte.",
    createStudentSuccess: "Etudiant créé avec succes",
    updateStudentSuccess: "Etudiant modifié avec succes",
    createStudentError:
      "Une erreur est survenue lors de la création de l'étudiant",
    updateStudentError:
      "Une erreur est survenue lors de la modification de l'étudiant",
    deleteStudentSuccess: "L'élève a bien été supprimé de la classe.",
    studentUnauthorizedToAccessHomework:
      "Vous n'êtes pas autorisé à accéder à ce devoir.",
  },
  blogs: {
    getBlogsError:
      "Une erreur a été rencontrée lors du chargement des notes de blog. Veuillez contacter le responsable de l'application svp.",
    getBlogError:
      "Une erreur a été rencontrée lors de la récupération de la note de blog. Veuillez contacter un technicien svp.",
    getBlogImageError:
      "Une erreur a été rencontrée lors de la récupération des images des notes de blog. Veuillez contacter un technicien svp.",
  },
  countries: {
    getCountriesError:
      "Une erreur a été rencontrée lors du chargement des pays. Veuillez contacter le responsable de l'application svp.",
    getCountryError:
      "Une erreur a été rencontrée lors de la récupération du pays. Veuillez contacter un technicien svp.",
    updateCountryError: "Erreur lors de la modification du pays",
    updateCountrySuccess: "Pays modifié avec succes.",
    createCountryError: "Erreur lors de la création du pays.",
    createCountrySuccess: "Pays créé avec succes.",
  },
  homework: {
    creationSuccess: "Devoir sauvegardé.",
    creationFailure: "Erreur lors de la création du devoir.",
    updateSuccess: "Devoir modifié.",
    updateFailure: "Erreur lors de la modification du devoir.",
    checkSubscriptionFailure:
      "Une erreur a été rencontrée lors du chargement de la page de création d'un devoir. Veuillez contacter le responsable de l'application svp.",
    expired: "La date de rendu est dépassée.",
    alreadyStarted:
      "Impossible de changer le statut de publication du devoir car au moins un élève à déjà commencé ce devoir.",
    cannotDeletePublishedHomework:
      "Impossible de supprimer des devoirs publiés.",
    cannotUpdatePublishedHomework:
      "Impossible de modifier des devoirs publiés.",
    getHomeworkError:
      "Une erreur a été rencontrée lors du chargement du devoir. Veuillez contacter le responsable de l'application svp.",
    retrieveHomeworksError:
      "Une erreur a été rencontrée lors de la récupération de vos devoirs. Veuillez contacter le responsable de l'application svp.",
    saveHomeworkError:
      "Une erreur a été rencontrée lors de la sauvegarde des données de votre devoir. Veuillez contacter le responsable de l'application svp.",
    deleteHomeworkSuccess: "Devoir supprimé avec succès.",
    deleteHomeworkError:
      "Une erreur a été rencontrée lors de la suppression du devoir. Veuillez contacter le responsable de l'application svp.",
    endTimer:
      "Votre devoir se termine dans une minute. N'oubliez pas de valider vos réponses.",
    noExerciseInHomework:
      "Ce devoir ne contient actuellement aucun exercice, veuillez contacter votre professeur.",
    gradeUnfinishedHomeworkSuccess:
      "Les devoirs non complétés ont été notés avec succès. Les données affichées ont été mises à jour.",
    mismatchedHomeworkData:
      "Ce devoir a déjà été réalisé et noté. Vous pouvez néanmoins le refaire s'il est toujours ouvert.",
  },
  exercise: {
    saveSuccess: "Exercice sauvegardé.",
    saveFailure: "Erreur lors de la sauvegarde de l'exercice.",
    getExercisesContentsError:
      "Une erreur a été rencontrée lors du chargement du sommaire des exercices. Veuillez contacter le responsable de l'application svp.",
    getExercisesError:
      "Une erreur a été rencontrée lors du chargement des exercices. Veuillez contacter le responsable de l'application svp.",
    getExerciseError:
      "Une erreur a été rencontrée lors du chargement de l'exercice. Veuillez contacter le responsable de l'application svp.",
    getExerciseNotFound:
      "L'exercice n'existe pas ou n'est pas disponible. Veuillez contacter le responsable de l'application svp.",
    incompleteExercise: "L'exercice est incomplet.",
  },
  blog: {
    saveSuccess: "Note de blog sauvegardée.",
    saveFailure: "Erreur lors de la sauvegarde de la note de blog.",
    imageFailure:
      "L'image est trop lourde. Veuillez choisir une image plus légère (taille maximale : 1 Mo).",
    updateSuccess: "Note de blog modifiée.",
    updateFailure: "Erreur lors de la modification de la note de blog.",
    deleteSuccess: "La note de blog a bien été supprimée.",
    deleteFailure: "Erreur lors de la suppression de la note de blog.",
    completedInAllLanguages:
      "Les champs titre, mots-clés et description doivent être remplis dans toutes les langues.",
  },
  user: {
    loginTimeout: "Votre session a expiré",
    editionSuccess: "Vos informations ont été sauvegardées",
    editionFailure: "Erreur lors de la sauvegarde de vos informations",
    deleteSuccess:
      "Votre compte a bien été supprimé. À bientôt sur iizenglish !",
    loadingDataError:
      "Une erreur est survenue lors de l'initialisation de votre session",
    sessionLost:
      "Votre session a expiré. Veuillez vous reconnecter pour continuer.",
  },
  account: {
    deleteSuccess: "Le compte a bien été supprimé.",
    deleteFailure: "Erreur lors de la suppression du compte.",
    accountActivated: "Compte activé",
    accountNotActivated: "Compte non activé",
    accountDoesNotExists: "Aucun compte n'est associé à cette adresse email.",
    pendingAccountExists:
      "Un compte en attente de validation associé à cet email existait déjà.",
  },
  garSubscriptions: {
    getSubscripionsError:
      "Une erreur est survenue lors de la récupération des abonnements du GAR",
    getSubscripionError:
      "Une erreur est survenue lors de la récupération de l'abonnement du GAR",
    getEstablishmentsError:
      "Une erreur est survenue lors de la récupération des établissements du GAR",
    createSubscripionError:
      "Une erreur est survenue lors de la création de l'abonnement.",
    createSubscripionSuccess: "Abonnement GAR créé avec succès !",
    updateSubscripionError:
      "Une erreur est survenue lors de la mise à jour de l'abonnement.",
    updateSubscripionSuccess: "Abonnement GAR mis à jour avec succès !",
    deleteSubscripionSuccess: "L'abonnement a bien été supprimé.",
    deleteSubscripionError:
      "Une erreur est survenue lors de la suppression de l'abonnement.",
  },
  teachers: {
    getTeacherStudentsError:
      "Une erreur est survenue lors de la récupération de vos élèves.",
    getTeacherSchoolsError:
      "Une erreur est survenue lors de la récupération de vos établissements.",
    retrieveTeachersError:
      "Une erreur a été rencontrée lors de la récupération des enseignants. Veuillez contacter un technicien svp.",
    updateTeacherSuccess: "Enseignant modifié avec succès",
    updateTeacherEmailError:
      "L'adresse e-mail est déjà utilisée. Impossible de modifier le professeur",
    updateTeacherPasswordError: "Le mot de passe est requis pour l'activation.",
    createTeacherSuccess: "Enseignant créé avec succès",
    createTeacherError:
      "Un problème est survenu lors de la création du professeur",
    createTeacherPasswordError: "Le mot de passe est requis pour l'activation.",
    createTeacherEmailError:
      "L'adresse e-mail est déjà utilisée. Impossible de créer le professeur.",
    setGradingSystemError:
      "Une erreur est survenue lors de l'enregistrement de vos préférences. Merci de contacter un responsable si l'erreur persiste.",
    setGradingSystemSuccess: "Votre système de notation a bien été enregistré.",
  },
  fieldsError: "Certains champs comportent des erreurs.",
  sendReminderSuccess: "Relance envoyée",
  sendReminderError:
    "Une erreur a été rencontrée lors de l'envoi de la relance. Veuillez contacter le responsable de l'application svp.",
  emptyAnswer: "Votre réponse est vide.",
  emptyAnswerRemaining: "Il reste au moins une réponse vide.",
  incompleteHomework: "Le devoir est incomplet.",
  noAnswerSelected: "Vous n'avez pas sélectionné de réponse.",
  noAnswerMoved: "Vous n'avez déplacé aucune réponse.",
  clickAgainToValidate:
    "Cliquez de nouveau sur le bouton si vous voulez quand même valider.",
  clickAgainToGoBack:
    "Vous n'avez pas sauvegardé vos modifications. Cliquez de nouveau sur le bouton Retour si vous voulez quitter sans sauvegarder.",
  clickAgainToGoToExercise:
    "Cliquez de nouveau sur le bouton si vous voulez quand même changer d'exercice. Les données non validées seront perdues.",
  clickAgainToFinish:
    "Cliquez de nouveau sur le bouton si vous voulez quand même terminer le devoir.",
  tableofcontentResetSuccess: "Sommaire réinitialisé !",
  tableofcontentResetError: "Erreur lors de la réinitialisation du sommaire.",
  errorOccuredUpdating:
    "Un problème est survenu lors de la mise à jour des informations. Veuillez contacter un administrateur.",
  resources: {
    getResourcesError:
      "Une erreur est survenue lors de la récupération des ressources. Veuillez contacter un administrateur.",
    updateDescriptionError:
      "Une erreur est survenue lors de la mise à jour de la description. Veuillez contacter un administrateur.",
  },
  messageDontMatch: "Le message ne correspond pas",
  twoFactorAuth: {
    incorrectCode: "Code invalide.",
    expiredCode:
      "Code de validation expiré. Veuillez faire une nouvelle demande.",
    validationError:
      "Une erreur est survenue. Veuillez faire une nouvelle demande.",
    newRequestSent:
      "Un nouveau code de vérification vous a été envoyé par mail.",
  },
  missingStudentsLevelPart1:
    "Certains étudiants concernés par ce devoir n'ont pas de niveau affecté. Cliquez de nouveau sur le bouton",
  missingStudentsLevelPart2: "pour passer à la suite.",
  subscriptions: {
    updateHideReminderError:
      "Une erreur est survenue lors de la mise à jour des paramètres de votre abonnement. Veuillez contacter un administrateur.",
  },
  mockExams: {
    importSuccess: "Examens blancs importés avec succès!",
    importError: "Une erreur est survenue durant l'import.",
    getMockExamsTableOfContentsError:
      "Une erreur a été rencontrée lors du chargement du sommaire des examens blancs. Veuillez contacter le responsable de l'application svp.",
    getMockExamError:
      "Une erreur a été rencontrée lors du chargement de l'examen blanc. Veuillez contacter le responsable de l'application svp.",
  },
  globalParameters: {
    updateValueError:
      "Une erreur est survenur lors de la mise à jour de la valeur du paramètre. Veuillez contacter le responsable de l'application svp.",
    updateValueSuccess: "Le paramètre a été mis à jour avec succès.",
    resetValueSuccess: "Le paramètre a été réinitialisé avec succès.",
    listError:
      "Une erreur est survenur lors de la récupération des paramètres. Veuillez contacter le responsable de l'application svp.",
    simplifiedListError:
      "Une erreur est survenur lors du chargement de l'application. Veuillez ré-essayer plus tard ou contacter le responsable de l'application svp.",
  },
};

export default notifications;
